import { render, staticRenderFns } from "./EditCollectionModal.vue?vue&type=template&id=2495f9d2&scoped=true"
import script from "./EditCollectionModal.vue?vue&type=script&lang=js"
export * from "./EditCollectionModal.vue?vue&type=script&lang=js"
import style0 from "./EditCollectionModal.vue?vue&type=style&index=0&id=2495f9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495f9d2",
  null
  
)

export default component.exports